export default __webpack_public_path__ + "static/media/016-certificate.ed213bd5.svg";